import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RemoteRecord } from '@client/common/redux/RemoteRecord';
import { AppState } from '@client/common/redux/store';
import { fetchProductGallery, selectProductGalleryBySku } from '@client/product/redux/productGallery/redux';
import { ProductGalleryType } from 'b2b-common/core/product/api/ProductGallery.types';

export const useProductGalleryEffect = (
  sku: string,
): RemoteRecord<ProductGalleryType> => {
  const dispatch = useDispatch();
  const gallery = useSelector(
    (state: AppState) => selectProductGalleryBySku(state, sku),
  );

  useEffect(
    (): void => {
      if (!gallery.wasStarted) {
        dispatch(fetchProductGallery({ sku }));
      }
    },
    [gallery.wasStarted, sku],
  );

  return gallery;
};
